<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal"
import Switches from "vue-switches";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import { required } from "vuelidate/lib/validators";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import restriccionesColaboracionesAPI from "../../../services/standards/restriccionesColaboraciones/restriccionesColaboracionesAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Restricciones y recomendaciones laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    Switches,
    PageHeader,
  },

  data() {
    return {
      title: "3.1.6 Restricciones y recomendaciones laborales",
      items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: "Restricciones y recomendaciones laborales",
        href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
          }/restricciones-colaboraciones`,
      },
      {
        text: 'Seguimientos',

      },
      {
        text: 'Editar',
        active: true,
      },
      ],

      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      userSelected: null,
      company: this.$store.getters["company/getCompany"] || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      usersList: [],
      lista: null,
      loading1: true,
      itemData: null,
      file: null,
      restriccionesColaboraciones: {
        labor_status: "En curso",
        recommendations: null,
        evidence: null,
        occupational_medical_danger_id: this.$route.params.id,
      },
      submitted: false,
    };
  },

  validations: {
    restriccionesColaboraciones: {
      recommendations: {
        required,
      },
      labor_status: {
        required,
      },
      evidence: {
        required,
      },
      occupational_medical_danger_id: {
        required,
      },

    },
  },
  methods: {
    saludar: function (event) {
      Swal.fire({
        icon: 'info',
        title: "Exito",
        type: "warning",
        confirmButtonClass: "btn btn-confirm mt-2",
        text: 'Por favor verifique todos los examenes para medicina ocupacional de' + ' ' + this.$store.getters["company/getCompany"].social_reason || null,
      });
    },

    getItemData() {
      ItemAPI.getItems(28)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },


    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.restriccionesColaboraciones.evidence)
        } else {
          name = this.file.name
        }
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.6/recomendaciones/${this.restriccionesColaboraciones.occupational_medical_danger_id}/seguimiento/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.6/recomendaciones/${this.restriccionesColaboraciones.occupational_medical_danger_id}/seguimiento/${this.$route.params.id}/${name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.restriccionesColaboraciones.evidence = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    get() {
      restriccionesColaboracionesAPI
        .getSpecific(this.$route.params.id)
        .then((response) => {
          this.restriccionesColaboraciones = {
            id: response.Labor.id,
            exam_date: response.Labor.exam_date,
            labor_status: response.Labor.labor_status,
            recommendations: response.Labor.recommendations,
            evidence: response.Labor.evidence,
            employee_id: response.Labor.employee_id,
            occupational_medical_danger_id: response.Labor.occupational_medical_danger_id,
          };
          this.loading1 = false
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false
        });
    },

    async update() {
      this.submitted = true
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        restriccionesColaboracionesAPI
          .update(this.$route.params.id, this.restriccionesColaboraciones)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 28,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => { })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
            this.loading1 = false
            Swal.fire({
              title: "¡Éxito!",
              text: "¡Informacion actualizada con éxito!",
              type: "success",
              icon: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            this.$router.go(-1);
          }).catch((err) => {
            console.log("Medicine error: ", err);
          });

      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error",
            text: "¡No se ha podido actualizar!, error documento",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 2000)
      }
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.loading1 = false
              this.usersList = res
            })
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false
        });
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getUsers();
    this.get()
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">

          <div class="card">
            <div class="card-body">
              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-12 px-2" label="Agregar seguimiento" label-for="note">
                    <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" type="date" id="tooltip7"
                      v-model="restriccionesColaboraciones.recommendations"
                      :class="{ 'is-invalid': $v.restriccionesColaboraciones.recommendations.$error && submitted }">
                    </b-form-textarea>
                    <b-tooltip target="tooltip7" placement="left">"Indicar si la recomendación tiene algún seguimiento
                      para el colaborador."</b-tooltip>
                  </b-form-group>
                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="restriccionesColaboraciones.evidence
                        ? getFile(restriccionesColaboraciones.evidence)
                        : `Selecciona un archivo...`
                        " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                  <b-form-group class="col-md-12 px-2">
                    <b-form-checkbox id="checkbox-1" v-model="restriccionesColaboraciones.labor_status"
                      name="checkbox-1" value="Implementado" unchecked-value="En curso">
                      Seleccionar cuando las recomendaciones hayan sido implementadas en su totalidad
                    </b-form-checkbox>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
